function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x2: 1,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(255, 255, 255, 0.01)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(255, 255, 255, 0.20)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x2: 0,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(255, 255, 255, 0.20)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(255, 255, 255, 0.35)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 1,
  x2: 0,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(255, 255, 255, 0.35)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(255, 255, 255, 0.50)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 1,
  x2: 0,
  y1: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(255, 255, 255, 0.50)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(255, 255, 255, 0.75)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x2: 0,
  y1: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(255, 255, 255, 0.75)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(255, 255, 255, 0.85)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x2: 1,
  y1: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "rgba(255, 255, 255, 0.85)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "rgba(255, 255, 255, 1)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 70
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  d: "M0-100a100 100 0 0186.6 50",
  transform: "translate(100 100)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#b)",
  d: "M86.6-50a100 100 0 010 100",
  transform: "translate(100 100)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#c)",
  d: "M86.6 50A100 100 0 010 100",
  transform: "translate(100 100)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#d)",
  d: "M0 100a100 100 0 01-86.6-50",
  transform: "translate(100 100)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#e)",
  d: "M-86.6 50a100 100 0 010-100",
  transform: "translate(100 100)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#f)",
  d: "M-86.6-50A100 100 0 010-100",
  transform: "translate(100 100)"
}));

function SvgIconSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-40 -40 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinner);
export default __webpack_public_path__ + "static/media/icon-spinner.50e253f1.svg";
export { ForwardRef as ReactComponent };